export default __webpack_public_path__ + "static/sp-preview-98366c540312cd67f00de69eb46c882e.png";